import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { useHistory } from 'react-router-dom';
import {
  actions,
  ADMISSION_FORM_TYPES,
} from '../constants/crmConstants';
import { Payer } from '../models/payer.model';
import { PayerInitialState } from '../../store/models/payerListModel';
import { getIsPageNameNewAdmission } from '../../modules/crm/inPatient/service/crmUtils';
export const useNewAdmissionSubmitButton = (): any => {
  const history = useHistory();
  const { payer } = useSelector((state: RootState): PayerInitialState => state.payerList);
  const {
    uploadedFiles,
    admissionFormType,
  } = useSelector((state: RootState): any => state.newAdmission);
  const { claimDetails: { isConfirmable = '', nextAllowStatus = [] } = {} } =
    useSelector((state: RootState): any => state.admissionDetails) || {};
  const { isCorporatePayer }: Payer = payer;
  const [nextAllowed] = nextAllowStatus || [];
  const buttonText = admissionFormType === ADMISSION_FORM_TYPES.NORMAL ? isConfirmable ? 'Confirm' :  uploadedFiles.length ? 'Submit' : 'Next' : isCorporatePayer && (nextAllowed === actions.EDIT || getIsPageNameNewAdmission(history?.location?.pathname)) ? 'Save' : 'Submit';
  return buttonText;
};
